import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo_header_pc from '../../assets/images/gk88-logo.png';
import logo_header_mb from '../../assets/images/gk88-logo-mb.png';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };
  return (
    <header
      className="flex py-2 sm:px-10 bg-[#fff] font-[sans-serif] md:min-h-[100px] tracking-wide relative z-50"
      style={{ boxShadow: '0 3px 10px #f9ab6b8a' }}
    >
      <div className="flex flex-wrap items-center lg:justify-between w-full max-w-[1200px] mx-auto gap-5">
        <div className="flex items-center lg:hidden">
          <button
            className="lg:hidden p-2"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <svg
              className="w-7 h-7"
              fill="#fe6601"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                style={{ fillRule: 'evenodd', clipRule: 'evenodd' }}
                d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              ></path>
            </svg>
          </button>
        </div>
        <div className="w-[70%] md:w-[185px] flex justify-center lg:justify-start">
          <Link to="/" className="max-md:hidden focus:outline-none focus:ring-0">
            <img src={logo_header_pc} alt="GK88" className="w-full" />
          </Link>
          <Link to="/" className="hidden max-md:block focus:outline-none focus:ring-0">
            <img src={logo_header_mb} alt="GK88" className="max-w-[240px]" />
          </Link>
        </div>
        <div
          className={`${
            isMobileMenuOpen ? 'max-lg:block' : 'max-lg:hidden'
          } w-[80%] lg:!flex justify-between items-center max-lg:before:fixed max-lg:before:bg-orange max-lg:before:opacity-50 max-lg:before:inset-0 max-lg:before:z-50`}
        >
          <ul
            className={`lg:flex gap-x-1 max-lg:space-y-3 max-lg:fixed max-lg:bg-[#fff] max-lg:w-1/2 max-lg:min-w-[300px] max-lg:top-0 max-lg:left-0 max-lg:p-6 max-lg:h-full max-lg:shadow-md max-lg:overflow-auto z-50 ${
              isMobileMenuOpen ? 'max-lg:block' : 'max-lg:hidden'
            }`}
          >
            <li className="mb-6 hidden max-lg:flex justify-between items-center">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="focus:outline-none focus:ring-0"
              >
                <img src={logo_header_mb} alt="GK88" className="w-45" />
              </Link>
              <button
                onClick={toggleMobileMenu}
                className="p-2 text-gray-600 hover:text-gray-800"
                aria-label="Close menu"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </li>
            <li className="flex justify-center gap-3 md:hidden">
              <a
                href="/"
                target="_blank"
                className="flex w-[120px] sm:w-[140px] px-1 lg:px-[18px] max-md:py-[6px] py-[9px] justify-center items-center gap-[10px] rounded-[30px] text-white font-bold text-[12px] lg:text-[15px] uppercase bg-[#fe6601] border-[#fe6601] hover:brightness-110"
              >
                Đăng Nhập
              </a>
              <a
                href="/"
                target="_blank"
                className="flex w-[120px] sm:w-[140px] px-1 lg:px-[18px] max-md:py-[6px] py-[9px] justify-center items-center gap-[10px] rounded-[30px] font-bold text-[12px] lg:text-[15px] uppercase text-white border border-[#b20000] bg-[#b20000] hover:brightness-105"
              >
                Đăng Ký
              </a>
            </li>
            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
              <Link
                to="/"
                className={`block font-semibold text-[18px] no-underline hover:no-underline focus:outline-none focus:ring-0 ${
                  location.pathname === '/' ? 'text-[#fe6601]' : 'text-[#000] hover:text-[#fe6601]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Trang Chủ
              </Link>
            </li>
            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
              <Link
                to="/about"
                className={`block font-semibold text-[18px] no-underline hover:no-underline focus:outline-none focus:ring-0 ${
                  location.pathname === '/about'
                    ? 'text-[#fe6601]'
                    : 'text-[#000] hover:text-[#fe6601]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Về Chúng Tôi
              </Link>
            </li>
            <li className="max-lg:border-b border-gray-300 max-lg:py-3 px-3">
              <Link
                to="/charity"
                className={`block font-semibold text-[18px] no-underline hover:no-underline focus:outline-none focus:ring-0 ${
                  location.pathname === '/charity'
                    ? 'text-[#fe6601]'
                    : 'text-[#000] hover:text-[#fe6601]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Quỹ Thiện Nguyện
              </Link>
            </li>
          </ul>
          <div className="flex items-center gap-2 lg:gap-4 max-md:hidden">
            <a
              href="/"
              target="_blank"
              className="flex bg-[#fe6601] border-[#fe6601] hoverCT w-[10px] sm:w-[140px] px-1 lg:px-[18px] max-md:py-[6px] py-[9px] justify-center items-center gap-[10px] rounded-[30px] text-[#FFF] font-bold text-[12px] lg:text-[15px] uppercase no-underline hover:no-underline focus:outline-none focus:ring-0"
            >
              Đăng nhập
            </a>
            <a
              href="/ "
              target="_blank"
              className="flex bg-[#b20000] hoverCT w-[90px] sm:w-[140px] px-1 lg:px-[18px] max-md:py-[6px] py-[9px] justify-center items-center gap-[10px] rounded-[30px] border-[#b20000] font-bold text-[12px] lg:text-[15px] uppercase text-[#FFF] no-underline hover:no-underline focus:outline-none focus:ring-0"
            >
              Đăng ký
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
